import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

import type { Color } from "app/pages/activation/components/RankWidget/types";

const { blue, carbon } = colorsPalettes;

export const Container = styled(FlexRow)<{ isDisabled?: boolean; color?: Color }>`
    ${setFontVariant("body1", blue[400])};
    align-items: center;
    gap: 8px;

    ${({ color }) =>
        color &&
        css`
            color: ${color};
        `};

    ${({ isDisabled, color }) =>
        isDisabled
            ? css`
                  color: ${carbon[400]};
                  cursor: default;
              `
            : css`
                  border-bottom: 1px solid ${color ?? blue[400]};
                  width: max-content;
                  cursor: pointer;
              `};

    .SWReactIcons {
        box-sizing: border-box;
        display: ${({ isDisabled }) => (isDisabled ? "none" : "flex")};
        align-items: center;
        justify-content: center;
    }
`;
